import { Box, Typography, Grid } from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';

const fontFamily = '"Inter", sans-serif';

const ProposalViewGuarantees = ({ guarantees = [] }) => {
  // Hide section if no guarantees selected
  if (!guarantees || guarantees.length === 0) return null;

  return (
    <Box sx={{ mb: 4, px: 2 }}>
      {/* Header - same style as Warranties */}
      <Box sx={{ display: 'inline-block', mb: 0 }}>
        <Box
          sx={{
            backgroundColor: '#0d3c61',
            color: '#fff',
            px: 2,
            py: 0.75,
          }}
        >
          <Typography
            sx={{
              fontFamily,
              fontWeight: 600,
              fontSize: 14,
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
            }}
          >
            Maxx Guarantees
          </Typography>
        </Box>
      </Box>

      {guarantees && guarantees.length > 0 ? (
        <Grid container spacing={2} alignItems="stretch">
          {guarantees.map((guarantee, index) => (
            <Grid item xs={12} sm={6} key={index} sx={{ display: 'flex' }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 1.5,
                  p: 2,
                  backgroundColor: '#f8f9fa',
                  borderRadius: 1,
                  width: '100%',
                  height: '100%',
                }}
              >
                <VerifiedIcon sx={{ fontSize: 24, color: '#0d3c61', flexShrink: 0, mt: 0.25 }} />
                <Typography
                  sx={{
                    fontFamily,
                    fontWeight: 500,
                    fontSize: 13,
                    color: '#1a1a1a',
                    lineHeight: 1.5,
                  }}
                >
                  {guarantee.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography
          sx={{
            fontFamily,
            fontSize: 13,
            color: '#666',
            fontStyle: 'italic',
          }}
        >
          No guarantees selected
        </Typography>
      )}
    </Box>
  );
};

export default ProposalViewGuarantees;
